import moment from "moment";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import EndPoints from "src/Constants/EndPoints";
import useLoading from "src/Hooks/Custom/useLoading";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import { useTranslation } from "react-i18next";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import { useState } from "react";

function SalePostDetail({
  postData,
  setPostData,
  setDetailView,
  setModalVisibility,
}: any) {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const subId = user?.username;
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [confirmAction, setConfirmAction] = useState<Function>();
  const [actionStatus, setActionStatus] = useState<any>('');
  const { id, title, message, images, sale_price, timestamp } = postData;
  const detailViewHandler = (e: any) => {
    e.preventDefault();
    setPostData([]);
    setDetailView(false);
  };
  const editPostHandler = (e: any) => {
    e.preventDefault();
    setModalVisibility(true);
  };

  const [deletePost, { status: deleteStatus }] = useApiMutation();
  useLoading(deleteStatus);

  const deletePostHandler = () => {
    if (deleteStatus === "loading") {
      return;
    }
    deletePost({
      url: EndPoints.deletePost,
      data: {
        subId: user?.username,
        postId: id,
      },
    });
    setDetailView(false);
  };
  return (
    <>
      <div className="d-flex justify-content-between px-3">
        <a
          className="d-flex mb-4 align-items-center"
          onClick={detailViewHandler}
          href="/"
        >
          <i className={`${i18n.dir()==='rtl'?'fa fa-angle-right fz24':'fa fa-angle-left fz24'}`} aria-hidden="true"></i>
          <h3 className={`fz16 mb-0 ${i18n.dir()==='rtl'?'mr-3':'ml-3'}`}>{t("Detail")}</h3>
        </a>
        <div className={`slider_down_arrow position-relative ${i18n.dir() === 'rtl'?'pr':'pl'}-4`}>
          <i className="fa fa-angle-down fz26" aria-hidden="true"></i>
          <div className={`user_actions ${i18n.dir()==='rtl'?'user_actions_posRTL':'user_actions_posLTR'}`}>
            <ul className={`list-unstyled  ${i18n.dir()==='rtl'?'text-right Almaraisemibold':'text-left poppinsbold'} mb-0 `}>
              <VisibilityToggle visible={user.username === subId}>
                <li>
                  <a className="py-4" href="/" onClick={editPostHandler}>
                    <i
                      className={`fa fa-pencil fz18  ${i18n.dir()=== 'rtl'? "ml-4 " : "mr-4"}`}
                      aria-hidden="true"
                    ></i>
                    {t("Edit")}
                  </a>
                </li>
              </VisibilityToggle>
              <VisibilityToggle visible={user.username === subId}>
                <li>
                  <a className="py-4" href="/" onClick={(e) => {
                    e.preventDefault();
                    setConfirmModal(true);
                    setActionStatus(() => deleteStatus);
                    setConfirmAction(() => deletePostHandler);
                  }}>
                    <i className={`fa fa-trash fz18  ${i18n.dir()=== 'rtl'? "ml-4 " : "mr-4"}`} aria-hidden="true"></i>
                    <VisibilityToggle visible={deleteStatus === "loading"}>
                      <span className="spinner-border spinner-border-sm"></span>
                      &nbsp; &nbsp;
                    </VisibilityToggle>
                    {t("Delete")}
                  </a>
                </li>
              </VisibilityToggle>
            </ul>
          </div>
        </div>
      </div>
      <div className="px-3">
        <div className="row">
          <div className="col-md-5">
            <div className="col_selector mb-5 mb-md-0">
              <img
                src={images[0].url}
                className="img-fluid w-100 rounded"
                alt=""
              />
              <div className="d-flex align-items-end py-3">
                <h2 className="fz20 poppinssemibold mb-0 mr-3">
                  {`${i18n.dir()==='rtl'?sale_price + ' دج':'DZD ' + sale_price}`}
                </h2>
                {/* <span className="fz16 poppinssemibold base_color">{t("Price")}</span> */}
              </div>
            </div>
          </div>
          <div className="col-md-7">
            <div className="col_selector">
              <div>
                <div className="mb-3 d-flex align-self-center">
                  <img
                    src="assets/images/Ellipse 5.png"
                    className= {`rounded-circle img-fluid ${i18n.dir()==='rtl'?'ml-4':'mr-4'} object_fit`}
                    width="40"
                    height="40"
                    alt=""
                  />
                  <h3 className={`fz16 mb-0 ${i18n.dir() === "rtl" ? " text-right" : "poppinssemibold"}`}>
                    {title}
                    <br />
                    <span className={`fz10  ${i18n.dir() === "rtl" ? "Almaraisemibold" : "poppinsregular"}`}>
                      {t("Posted")}:{" "}
                      {timestamp ? moment(new Date(timestamp)).fromNow() : ""}
                    </span>
                  </h3>
                </div>
                <p className={`fz12 poppinsregular ${i18n.dir()==='rtl'?'text-right pr-0':'pl-0'}`}>{message}</p>
                {/* <button className="btn custom_btn fz14 poppinsbold">
                  Message
                </button> */}
              </div>
            </div>
          </div>
        </div>
        {
          confirmModal ? (
            <ConfirmModal
              showModal={confirmModal}
              setModalVisibility={setConfirmModal}
              confirmAction={confirmAction}
              ConfirmationText={"Are you sure?"}
              CancelBtnText={"Cancel"}
              ConfirmBtnText={"Yes"}
              status={actionStatus}
              setActionStatus={setActionStatus}
            />
          ) : (
              <></>
            )
        }
      </div>
    </>
  );
}

export default SalePostDetail;
